module.exports = __webpack_public_path__ + "static/media/withdraw-big-icon.60c1717f.svg";